import {SC_CrewBase} from "../crews/SC_CrewBase";

export class SC_CrewType {
    static readonly NULL = 0;
    static readonly EMPLOYEE_BACKED = 1;
    static readonly SUB = 2;

    constructor(private type: number = SC_CrewType.NULL) { }

    static fromAPI(apiValue: number): SC_CrewType {
        switch (apiValue) {
            case SC_CrewType.EMPLOYEE_BACKED:
                return new SC_CrewType(SC_CrewType.EMPLOYEE_BACKED);
            case SC_CrewType.SUB:
                return new SC_CrewType(SC_CrewType.SUB);
            default:
                return new SC_CrewType();
        }
    }

    is(type: number): boolean {
        return this.type === type;
    }

    toAPI(): number {
        return this.type;
    }

    clone(): SC_CrewType {
        return new SC_CrewType(this.type);
    }

    merge(other: SC_CrewType): SC_CrewType {
        if (other.type !== SC_CrewType.NULL) {
            this.type = other.type;
        }

        return this;
    }

    static readonly crewTypes = [
        { key: SC_CrewType.NULL, display: "Not Set" },
        { key: SC_CrewType.EMPLOYEE_BACKED, display: "Crew" },
        { key: SC_CrewType.SUB, display: "Subcontractor" },
    ];

    toString(): string {
        switch (this.type) {
            case SC_CrewType.SUB:
                return "Subcontractor";
            case SC_CrewType.EMPLOYEE_BACKED:
                return "Crew";
            default:
                return "Not Set";
        }
    }

    crewMatches(crew: SC_CrewBase): boolean {
        return this.type == SC_CrewType.NULL || (crew.isSub == (this.type === SC_CrewType.SUB));
    }
}
